import { Http, Url } from '@intelipost-js/secure-providers';

export default {
  generateReport(context, config) {
    const {
      occurrence,
      vision,
      region,
      period,
      dateRange,
    } = config.filters;

    context.commit('setLoading', true);

    const estimatedDelivery = vision === 'user'
      ? 'client_estimated_delivery_date'
      : 'logistic_provider_estimated_delivery_date';

    const params = {
      date_type: period,
      view_type: vision,
      with_clarify_delivery_fail: occurrence,
    };

    const pathParams = [
      estimatedDelivery,
      dateRange.start,
      dateRange.end,
      region || 'all',
      'id',
      'ascending',
      config.pagination.limit,
      config.pagination.page,
    ];

    return Http.get(Url.toQueryString('api/v1/dashboard', params, pathParams)).then((res) => {
      context.commit('setReportData', res.data.content);
      context.commit('setLoading', false);
    }).catch(() => context.commit('setLoading', false));
  },
  exportReport(context, config) {
    const {
      occurrence,
      vision,
      region,
      period,
      dateRange,
    } = config.filters;

    const estimatedDelivery = vision === 'user'
      ? 'client_estimated_delivery_date'
      : 'logistic_provider_estimated_delivery_date';

    const params = {
      date_type: period,
      view_type: vision,
      with_clarify_delivery_fail: occurrence,
    };

    const pathParams = [
      estimatedDelivery,
      'excel',
      dateRange.start,
      dateRange.end,
      region || 'all',
      'id',
      'ascending',
    ];

    return Http.get(Url.toQueryString('api/v1/dashboard', params, pathParams)).then(() => {
      context.commit('setExportLoading', false);
    }).catch(() => context.commit('setExportLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/performance/store/actions.js